var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcPedidoPreparacao = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:none;stroke:#2ABA83;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#2ABA83;}\r\n\t.st2{fill:#D4145A;}\r\n\t.st3{fill:#363636;}\r\n\t.st4{display:none;}\r\n\t.st5{display:inline;}\r\n\t.st6{fill:#30323A;}\r\n\t.st7{font-family:'Poppins-Regular';}\r\n\t.st8{font-size:3.9346px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bolsas_e_Olheiras"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Hidratante"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Repelente"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guias"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Barba"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Calv\\xEDcie"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Clareador"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Beleza"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Iluminador"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Preechedor"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Crescimento_Capilar"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Pesco\\xE7o_e_Colo"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Cabelo"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Sa\\xFAde"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Unha"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Protetor_Solar"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Texto"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.72,33.84l-3.55,2.18c-0.24,0.14-0.31,0.45-0.16,0.69c0.09,0.15,0.26,0.24,0.43,0.24c0.09,0,0.18-0.02,0.26-0.07 l3.55-2.18c0.24-0.14,0.31-0.45,0.16-0.69C38.27,33.77,37.96,33.7,37.72,33.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68,36.8l-2.51,1.58c-0.23,0.15-0.3,0.46-0.16,0.69c0.1,0.15,0.26,0.23,0.42,0.23c0.09,0,0.18-0.02,0.27-0.08 l2.51-1.58c0.23-0.15,0.3-0.46,0.16-0.69C37.22,36.72,36.91,36.66,36.68,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6,19.99l-13.45-7.48c-0.13-0.08-0.3-0.08-0.44-0.02c-0.14,0.06-0.25,0.18-0.29,0.33l-1.57,5.69l-10.37,5.99 l-6.17-3.73c-0.2-0.12-0.47-0.09-0.63,0.09c-0.16,0.18-0.17,0.44-0.03,0.63l3.86,5.18V42.9c0,0.17,0.09,0.33,0.24,0.43l13.27,8.2 c0,0,0.01,0,0.01,0c0,0,0,0.01,0.01,0.01c0.08,0.04,0.16,0.06,0.24,0.06s0.17-0.02,0.24-0.06c0,0,0-0.01,0.01-0.01 c0,0,0.01,0,0.01,0l13.27-8.2c0.15-0.09,0.24-0.25,0.24-0.43V26.57l1.78-6C47.9,20.35,47.8,20.11,47.6,19.99z M32.78,33.8V19.7 l11.8,6.81L32.78,33.8z M31.78,19.7v13.17l-1.9-3.22c-0.04-0.07-0.1-0.13-0.17-0.17l-7.25-4.39L31.78,19.7z M29.08,30.26 l1.74,2.94l-11.47-7.09l-2.37-3.18L29.08,30.26z M19.51,27.39l12.27,7.59v15.23l-12.27-7.58V27.39z M32.78,50.21V34.98l12.27-7.59 v15.23L32.78,50.21z M45.26,25.75l-12.39-7.15l1.35-4.9l12.54,6.98L45.26,25.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "label",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 8.5634 59.6407)",
    className: "st6 st7 st8"
  }, "Pedido em prepara\xE7\xE3o"))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPedidoPreparacao, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-pedido-preparacao.2a0f122f.svg";
export { ForwardRef as ReactComponent };